import { Component } from '@angular/core';
import { SandeeApi } from 'api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'at-in-village';

  img = "../assets/menu (2).png"
  name; email; tel;
  name_reg; email_reg; tel_reg;  
  
  menu() {
    if(this.img == '../assets/menu (2).png') {
  		this.img='../assets/close.png';
  	} else {
		  this.img = '../assets/menu (2).png';
  	}
  }

  register() {
    if (this.name_reg !== '' && this.name_reg !== undefined &&
      // this.email !== '' && this.email !== undefined &&
      this.tel_reg !== '' && this.tel_reg !== undefined) {
      const info_reg = { name_reg: this.name_reg, email_reg: this.email_reg, tel_reg: this.tel_reg }
      const data_reg = {
        msg: {
          personalizations: [
            {
              to: [
                {
                  email: 'leadnotify.grit@gmail.com'
                },
                {
                  email: 'win@gritworld.co.th'
                }
                // {
                //   email: 'biw.a.srichumpa@gmail.com'
                // }
              ],
              subject: 'Contact from at-in-village.web.app'
            }
          ],
          from: {
            name: 'ข้อมูลผู้ที่สนใจ : At In Village ',
            email: 'office.gritworld@gmail.com'
          },
          content: [
            {
              type: 'text/html',
              value:  'name: ' + info_reg.name_reg + '<br>' +
                      'email: ' + info_reg.email_reg + '<br>' +
                      'tel: ' + info_reg.tel_reg + '<br>'
            }
          ]
        }
      }
      return SandeeApi.sendEmail(data_reg)
        .then(response => {
          console.log(response);
          alert('การส่งช้อมูลสำเร็จ');
          this.name_reg = ''; this.tel_reg = ''; this.email_reg = '';
        }).catch(err => {
          alert(err);
        })
    } else {
      alert('โปรดกรอกชื่อและเบอร์โทรให้ครบ');
    }
  }

  submit() {
    if (this.name !== '' && this.name !== undefined &&
      // this.email !== '' && this.email !== undefined &&
      this.tel !== '' && this.tel !== undefined) {
      const info = { name: this.name, email: this.email, tel: this.tel }
      const data = {
        msg: {
          personalizations: [
            {
              to: [
                {
                  email: 'leadnotify.grit@gmail.com'
                },
                {
                  email: 'win@gritworld.co.th'
                }
                // {
                //   email: 'biw.a.srichumpa@gmail.com'
                // }
              ],
              subject: 'Contact from at-in-village.web.app'
            }
          ],
          from: {
            name: 'ข้อมูลผู้ที่สนใจ : At In Village ',
            email: 'office.gritworld@gmail.com'
          },
          content: [
            {
              type: 'text/html',
              value:  'name: ' + info.name + '<br>' +
                      'email: ' + info.email + '<br>' +
                      'tel: ' + info.tel + '<br>'
            }
          ]
        }
      }
      return SandeeApi.sendEmail(data)
        .then(response => {
          console.log(response);
          alert('การส่งช้อมูลสำเร็จ');
          this.name = ''; this.tel = ''; this.email = '';
        }).catch(err => {
          alert(err);
        })
    } else {
      alert('โปรดกรอกชื่อและเบอร์โทรให้ครบ');
    }
  }

}
